import React, { FC } from 'react'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import VisiiConnector, { ConnectorProps as VisiiConnectorProps } from './connectors/VisiiConnector'
import VisualSearchIcon from 'svg/visual-search.svg'
import styles from './VisualSearchButton.module.scss'
import useQA from 'hooks/useQA'

const VisualSearchButton: FC<VisiiConnectorProps> = ({ visiiUrl }) => {
  const { testId } = useQA()

  return (
    <button
      className={styles.visiiButton}
      // onMouseDown instead of onClick because it needs to trigger before onBlur of the global search input field
      onMouseDown={() => {
        const location = addStoreLocaleByCookie(visiiUrl)
        window.location = location
      }}
      {...testId('visii-button')}
    >
      <VisualSearchIcon />
      <span>TRY VISUAL SEARCH</span>
    </button>
  )
}

export default VisiiConnector(VisualSearchButton)
